/**
 * Created by root on 8/30/15.
 */

// TODO: Review this later.

define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.AMSStatics = window.lpTag.AMSStatics || {};

    var _ = require('underscore');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var lpBaseConnectionListController = require('web-agent-assets-js/lpBaseConnectionListController');

    var model;
    var PARTICIPANT_ROLES = lpTag.AMSStatics.participant.roles;

    /* --------------------------------- Constructor --------------------------------- */

    var lpAppConnectionListController = lpBaseConnectionListController.extend(function AppConnectionListController(options) {
        model = options.model;
    });

    /* --------------------------------- Overrides --------------------------------- */

    lpAppConnectionListController.prototype.settings = {
        defaultSearchUIData: {
            limit: 50,
            skip: 0,
            sortTag: "SLA",
            sortOrder: "desc",
            filters: {
                conversationStates: {
                    selectedItems: [
                        lpAMSController.BADGES.IN_SURVEY,
                        lpAMSController.BADGES.NO_ACTIVE_DIALOG,
                        lpAMSController.BADGES.IN_QUEUE,
                        lpAMSController.CONVERSATION_STATES.OPEN,
                        lpAMSController.BADGES.FIRST_TIME,
                        lpAMSController.BADGES.URGENT,
                        lpAMSController.BADGES.OVERDUE
                    ].join(',')
                }
            }
        }
    };

    lpAppConnectionListController.prototype.applicationType = 'lpAppConnectionListController';

    lpAppConnectionListController.prototype.extendConversation = function (conversation) {
        var mainDialog = getMainDialog(conversation);
        var managerProfiles = getManagersProfiles(mainDialog);
        return {
            managerParticipantsCount: getManagerParticipantsCount(managerProfiles || []),
            managerParticipantsUnreadData: getManagerParticipantsUnreadData(conversation, managerProfiles),
            assignedAgentUnreadCount: getUnreadCount(conversation, conversation.assignedAgentId)
        };
    };

    function getUnreadCount(conversation, agentId) {
        if (agentId) {
            if (conversation && conversation.conversationDetails.state === lpAMSController.CONVERSATION_STATES.OPEN &&
                conversation.numberOfunreadMessages && conversation.numberOfunreadMessages.hasOwnProperty(agentId)) {
                return +conversation.numberOfunreadMessages[agentId];
            } else {
                return 0;
            }
        }
    }

    function getMainDialog(conversation) {
        return _.find(conversation.conversationDetails.dialogs, function(dialog) { return dialog.dialogType === lpAMSController.DIALOG_TYPES.MAIN; });
    }

    function getManagersProfiles(dialog) {
        var managers = _.filter(dialog.participantsDetails, function (participant) {
            return participant.role === PARTICIPANT_ROLES.MANAGER;
        });
        return _.map(managers, function (manager) {
            return getProfile(manager.agentId);
        });
    }

    function getProfile(userId) {
        return model.get('userProfiles.' + userId);
    }

    function getManagerParticipantsCount(managers) {
        return managers.length;
    }

    function getManagersUnreadCountMap(conversation, managerProfiles) {
        return _.pick(conversation.numberOfunreadMessages, function (val, key) {
            return !!_.find(managerProfiles, function(managerProfile) { return managerProfile && managerProfile.userId === key; });
        });
    }

    function getManagerParticipantsUnreadData(conversation, managerProfiles) {
        if (!managerProfiles) {
            return;
        }
        return _.reduce(getManagersUnreadCountMap(conversation, managerProfiles), function (accum, count, userId) {
            var userProfile = _.find(managerProfiles, {userId: userId});
            if (userProfile && userProfile.fullName) {
                accum.push({
                    managerName: userProfile.fullName,
                    managerUnreadCount: count,
                    managerDeleted: userProfile.isDeleted ? window.LE.translator.translate('LEWebAgent.agent_deleted_indication') + ' ' : ''
                });
            } else {
                accum.push({
                    managerName: window.LE.translator.translate ('LEWebAgent.notAvailable'),
                    managerUnreadCount: 0
                });
            }
            return accum;
        }, []);
    }

    return lpAppConnectionListController;

});
